import constants from 'Constants.js';
import util from 'util/Util.js';
import textUtil from 'util/TextUtil.js'

let self = undefined;
let fieldsWithEncryptionAttribute = [constants.CONTROL_TYPE_TEXTINPUT, constants.CONTROL_TYPE_MASKTEXTINPUT, constants.CONTROL_TYPE_PASSWORDINPUT];

class FormMetadataService {
    constructor() {
        self = this;
    }

    renderMetadata(Object) {
        let form = Object.Form;
        let ResponseMetaData = {};
        ResponseMetaData.Fields = {};
        ResponseMetaData.Fields.Object = [];
        if (form.Objects.Object && form.Objects.Object.length > 0) {
            form.Objects.Object.forEach(function (object) {
                if (object._type.toLowerCase() === constants.FIELD_METADATA_TYPE_GROUP) {
                    let objectInGroup = self.renderMetadataGroup(object, '')
                    if (objectInGroup) {
                        ResponseMetaData.Fields.Object.push(objectInGroup);
                    }
                }
            });
        }

        return ResponseMetaData;
    }

    renderMetadataGroup(group, namePath) {
        let _namePath = '';
        let Object = {};
        Object._id = group._id;
        Object._name = group._name;
        Object.Object = [];
        let isPage = typeof namePath === 'undefined' || namePath === '';
        if (namePath !== '') {
            _namePath = namePath + '|';
        }

        let listOfRadios = [];
        let listOfCheckboxes = [];

        if (group.Objects && group.Objects.Object && group.Objects.Object.length > 0) {
            group.Objects.Object.forEach(function (object) {
                let _Object;
                if (object._type.toLowerCase() === constants.FIELD_METADATA_TYPE_GROUP) {
                    _Object= self.renderMetadataGroup(object, _namePath + Object._name)
                    if (_Object) {
                        Object.Object.push(_Object);
                    }
                }
                else {
                    _Object = self.renderMetadataGeneric(object, _namePath + Object._name);
                    if (_Object) {
                        Object.Object.push(_Object);
                    }
                }

                if (object._type.toLowerCase() === 'radiobutton') {
                    listOfRadios.push(object);
                } else if (object._type.toLowerCase() === 'tickbox') {
                    listOfCheckboxes.push(object);
                }
            });

            if (listOfRadios.length || listOfCheckboxes.length) {
                let values = [];
                let maxLength = 0;
                let valuesAreNumbers = listOfRadios.length > 0;
               
                listOfRadios.forEach((radioObject, idx) => {
                    values.push({
                        _index: idx,
                        _caption: radioObject.Properties._text,
                        _relFieldId: radioObject._id,
                        $: radioObject.Properties._value
                    });
                    
                    if(!textUtil.isNumeric(radioObject.Properties._value)){
                        valuesAreNumbers = false;
                    }

                    maxLength = Math.max(maxLength, radioObject.Properties._text.length);
                });
                
                listOfCheckboxes.forEach((checkboxObject, idx) => {
                    values.push({                        
                        _relFieldId: checkboxObject._id,
                        _isCheckbox: 'true',
                        $: checkboxObject.Properties._text
                    });
                    
                    maxLength = Math.max(maxLength, checkboxObject.Properties._text.length);
                }); 

                const type = valuesAreNumbers ? "int" : `string(${maxLength})`;

                if (isPage){
                    Object.Field = {
                        _id: group._id,
                        _name: group._name,
                        _type: `string(${maxLength})`,
                        _isArray: true,
                        _hasValues: ((listOfRadios.length + listOfCheckboxes.length) > 0), //There must be at least one radio button or checkbox to be true
                        Value: values
                    };
                }else{
                    Object.Field = {
                        _id: group._id + '$v',
                        _type: type,
                        _name: namePath + '|' + group._name + ' - Value',
                        _hasValues: ((listOfRadios.length + listOfCheckboxes.length) > 0), //There must be at least one radio button or checkbox to be true
                        _default: '',
                        _hasCaptions: (listOfRadios.length > 0), //There must be at least one radio button to be true
                        _captionId: group._id,
                        _captionType: `string(${maxLength})`,
                        _captionName: namePath + '|' + group._name + ' - Caption',
                        _captionDefault: '',
                        /* changed to false, radio button group label goes missing when true, PF-6097 */
                        _isArray: false, 
                        Value: values
                    };
                }
            }
        }

        return Object.Object.length > 0 ? Object : undefined;
    }

    renderMetadataGeneric(object, namePath) {
        let Object;
        let generateFields = self.resolveFieldGenerationStrategy(object._type);
        if (generateFields) {
            Object = {};
            Object._id = object._id;
            Object._name = object._name;
            Object.Field = generateFields(object, namePath);
        }

        return Object;
    }

    resolveFieldGenerationStrategy(controlType) {
        let generateFields;
        switch (controlType.toLowerCase()) {
            case constants.CONTROL_TYPE_TEXTINPUT:
            case constants.CONTROL_TYPE_NUMERICINPUT:
            case constants.CONTROL_TYPE_DATE:
            case constants.CONTROL_TYPE_TIMEINPUT:
            case constants.CONTROL_TYPE_DATEINPUT:
            case constants.CONTROL_TYPE_RADIOBUTTON:
            case constants.CONTROL_TYPE_MASKTEXTINPUT:
            case constants.CONTROL_TYPE_NUMERICSTEPPER:
            case constants.CONTROL_TYPE_PASSWORDINPUT:
            case constants.CONTROL_TYPE_FILEATTACHMENT:
            case constants.CONTROL_TYPE_IMAGEIMPORT:
            case constants.CONTROL_TYPE_VERTICALSLIDER:
            case constants.CONTROL_TYPE_HORIZONTALSLIDER:
            case constants.CONTROL_TYPE_SHOWFORMBUTTON:
            case constants.CONTROL_TYPE_TEXTAREA:
            case constants.CONTROL_TYPE_TIMER:
            case constants.CONTROL_TYPE_CHECKBOX:
            case constants.CONTROL_TYPE_WEBSIGNATURESIMPLE:
                generateFields = self.generateField;
                break;
            case constants.CONTROL_TYPE_RANKING:
                generateFields = self.generateFieldRanking;
                break;
            /* drop and lists are the same */
            case constants.CONTROL_TYPE_DROPDOWN:
            case constants.CONTROL_TYPE_LIST:
                generateFields = self.generateFieldDropDownList;
                break;
            case constants.CONTROL_TYPE_TABLE:
                generateFields = self.generateFieldTable;
                break;
        }

        return generateFields;
    }

    generateField(object, namePath) {
        let Field = {};
        Field._id = object._id;
        Field._name = namePath !== '' ? namePath + '|' + object._name : object._name;
        Field._type = self.resolveFieldType(object);
        let defaultValue = self.resolveDefaultValue(object);
        if (typeof defaultValue !== 'undefined') {
            Field._default = defaultValue;
        }

        if (fieldsWithEncryptionAttribute.indexOf(object._type) >= 0) {
            Field._encrypt = object.Properties._encrypt;
        }

        if (object._type === 'tickbox'){
            Field._isCheckbox = 'true';
        }

        return Field;
    }

    generateFieldDropDownList(object, namePath) {
        let Field = {};
        let valuesArray = [];
        let captionsArray = [];
        Field._id = object._id + '$v';
        Field._captionId = object._id;
        Field._name = (namePath !== '' ? namePath + '|' + object._name : object._name) + ' - Value';
        Field._captionName = (namePath !== '' ? namePath + '|' + object._name : object._name) + ' - Caption';
        Field._type = self.resolveFieldType(object);

        let captionType = self.resolveDropDownListFieldType(object, 'captions');
        let stringLength = 0;
        let stringLengthStr = '';
        if (!object.Properties.Property || !object.Properties.Property[0].Item || object.Properties.Property[0].Item.length === 0) {
            captionType = constants.FIELD_METADATA_TYPE_STRING;
            stringLength = 100; //Default value when drop down is empty is string(100)
        } else {
            stringLength = self.resolveStringFieldLengthOnDropDown(object, 'captions');
        }

        if (captionType === constants.FIELD_METADATA_TYPE_STRING) {
            stringLengthStr = '(' + stringLength + ')';
        }

        Field._captionType = captionType + stringLengthStr;
        Field._default = '';
        Field._captionDefault = '';
        if (object.Properties.Property && object.Properties.Property.length > 0) {
            object.Properties.Property.forEach(function (property) {
                if (property._id === 'values' && property.Item && property.Item.length > 0) {
                    valuesArray = property.Item;
                    if (object._type === constants.CONTROL_TYPE_DROPDOWN) {
                        Field._default = property.Item[object.Properties._selectedIndex] ? property.Item[object.Properties._selectedIndex]._value : '';
                    }
                }
                if (property._id === 'captions' && property.Item && property.Item.length > 0) {
                    captionsArray = property.Item;
                    if (object._type === constants.CONTROL_TYPE_DROPDOWN) {
                        Field._captionDefault = property.Item[object.Properties._selectedIndex] ? property.Item[object.Properties._selectedIndex]._value : '';
                    }
                }
            });
        }

        Field._hasValues = true;
        Field._hasCaptions = true;
        Field.Value = [];
        let Value = {};
        for (var i = 0; i < valuesArray.length; i++) {
            Value = new String(valuesArray[i]._value);
            Value['_index'] = i;
            Value['_caption'] = captionsArray[i]._value;
            Field.Value.push(Value);
        }

        return Field;
    }

    generateFieldRanking(object, namePath){        
        let fields = [];
        if (object.Properties && object.Properties.Property){
            const ranks = object.Properties.Property.filter(item => item._id === 'ranks');            
            const captions = object.Properties.Property.filter(item => item._id === 'captions');
            if (ranks[0].Item){
                for(let i = 0; i < ranks[0].Item.length; i++){
                    fields.push({
                        _id: object._id + '$' + (parseInt(ranks[0].Item[i]._value)).toString(),
                        _type: 'int',
                        _name: namePath + '|' + object._name + '|' + captions[0].Item[i]._value
                    });
                }
            }
        }

        return fields;
    }

    generateFieldTable(object, namePath) {
        let result = [];
        object.Columns.Column = util.enforceArrayType(object.Columns.Column); //PF-6136 - COH User Application 6.1.1.3 OP - Saving the form is not working
        result = object.Columns.Column.map(col => {
            let _result = {
                _id: col._id,
                _type: self.resolveFieldType(col),
                _name: namePath + '|' + object._name + '|' + col._name,
                _isArray: true,
                _default: self.resolveDefaultValue(col),
                _groupId: object._id
            };

            if (col._type === constants.CONTROL_TYPE_TABLE_DROPDOWN){
                self.generateFieldTableDropDownList(col, _result);
            }

            return _result;
        });      

        return result;
    }

    generateFieldTableDropDownList(object, Field){
        let hasValues = false;
        let hasCaptions = false;
        let valuesArray = [];
        let captionsArray = [];

        let captionType = self.resolveDropDownListFieldType(object, 'captions');
        let stringLength = 0;
        let stringLengthStr = '';
        if (!object.Properties.Property || !object.Properties.Property[0].Item || object.Properties.Property[0].Item.length === 0) {
            captionType = constants.FIELD_METADATA_TYPE_STRING;
            stringLength = 100; //Default value when drop down is empty is string(100)
        } else {
            stringLength = self.resolveStringFieldLengthOnDropDown(object, 'captions');
        }

        if (captionType === constants.FIELD_METADATA_TYPE_STRING) {
            stringLengthStr = '(' + stringLength + ')';
        }

        Field._type = captionType + stringLengthStr;

        if (object.Properties.Property && object.Properties.Property.length > 0) {
            object.Properties.Property.forEach(function (property) {
                if (property._id === 'values' && property.Item && property.Item.length > 0) {
                    hasValues = true;
                    valuesArray = property.Item;
                    if (object._type === constants.CONTROL_TYPE_DROPDOWN) {
                        Field._default = property.Item[object.Properties._selectedIndex] ? property.Item[object.Properties._selectedIndex]._value : 0;
                    }
                }
                if (property._id === 'captions' && property.Item && property.Item.length > 0) {
                    hasCaptions = true;
                    captionsArray = property.Item;
                    if (object._type === constants.CONTROL_TYPE_DROPDOWN) {
                        Field._captionDefault = property.Item[object.Properties._selectedIndex] ? property.Item[object.Properties._selectedIndex]._value : 0;
                    }
                }
            });
        }

        Field._hasValues = hasValues;

        // PF-8768 to make it work as a drop down in reports
        Field._hasCaptions = hasCaptions;

        let type = self.resolveFieldType(object);

        if (!object.Properties.Property || !object.Properties.Property[0].Item || object.Properties.Property[0].Item.length === 0) {
            captionType = constants.FIELD_METADATA_TYPE_STRING;
            stringLength = 100; //Default value when drop down is empty is string(100)
        } else {
            stringLength = self.resolveStringFieldLengthOnDropDown(object, 'captions');
        }

        if (captionType === constants.FIELD_METADATA_TYPE_STRING) {
            stringLengthStr = '(' + stringLength + ')';
        }
        Field._type = type;
        Field._captionType = captionType + stringLengthStr;

        Field._id = object._id + '$v';
        Field._captionId = object._id;

        Field._captionName = Field._name + ' - Caption';
        Field._name = Field._name + ' - Value';
        
        Field.Value = [];
        let Value = {};
        for (var i = 0; i < valuesArray.length; i++) {
            Value = new String(valuesArray[i]._value);
            Value['_caption'] = captionsArray[i]._value;
            Field.Value.push(Value);
        }
    }

    resolveFieldType(object) {
        let controlType = object._type;
        let fieldType = 'unknown';
        if (controlType) {
            switch (controlType.toLowerCase()) {
                case constants.CONTROL_TYPE_TEXTINPUT:
                case constants.CONTROL_TYPE_TEXTAREA:
                case constants.CONTROL_TYPE_PASSWORDINPUT:
                case constants.CONTROL_TYPE_TABLE_CHILDFORMBUTTON.toLowerCase():
                case constants.CONTROL_TYPE_MASKTEXTINPUT:
                case constants.CONTROL_TYPE_TABLE_TEXTAREA.toLowerCase():
                case constants.CONTROL_TYPE_TABLE_TEXTINPUT.toLowerCase():
                case constants.CONTROL_TYPE_SHOWFORMBUTTON:
                    fieldType = constants.FIELD_METADATA_TYPE_STRING + self.resolveStringFieldLength(object);
                    break;
                case constants.CONTROL_TYPE_NUMERICINPUT:
                case constants.CONTROL_TYPE_TABLE_NUMERICINPUT.toLowerCase():
                    fieldType = object.Properties["_decimalLength"] > 0 ? constants.FIELD_METADATA_TYPE_DECIMAL : constants.FIELD_METADATA_TYPE_BIGINT;  
                    break;
                case constants.CONTROL_TYPE_DATEINPUT:
                case constants.CONTROL_TYPE_DATE:
                case constants.CONTROL_TYPE_TABLE_DATEINPUT.toLowerCase():
                    fieldType = constants.FIELD_METADATA_TYPE_DATE;
                    break;
                case constants.CONTROL_TYPE_TIMEINPUT:
                case constants.CONTROL_TYPE_TABLE_TIMEINPUT.toLowerCase():
                    fieldType = constants.FIELD_METADATA_TYPE_TIME;
                    break;
                case constants.CONTROL_TYPE_TIMER:
                case constants.CONTROL_TYPE_NUMERICSTEPPER:
                case constants.CONTROL_TYPE_VERTICALSLIDER:
                case constants.CONTROL_TYPE_HORIZONTALSLIDER:
                    fieldType = constants.FIELD_METADATA_TYPE_INT;
                    break;
                case constants.CONTROL_TYPE_CHECKBOX:
                case constants.CONTROL_TYPE_RADIOBUTTON:
                case constants.CONTROL_TYPE_TABLE_CHECKBOX.toLowerCase():
                case constants.CONTROL_TYPE_TABLE_RADIOBUTTON.toLowerCase():
                    fieldType = constants.FIELD_METADATA_TYPE_BOOLEAN;
                    break;
                case constants.CONTROL_TYPE_DROPDOWN:
                case constants.CONTROL_TYPE_TABLE_DROPDOWN.toLowerCase():
                case constants.CONTROL_TYPE_LIST:
                    fieldType = self.resolveDropDownListFieldType(object);
                    if (fieldType === constants.FIELD_METADATA_TYPE_STRING) {
                        fieldType = fieldType + self.resolveStringFieldLength(object);
                    }
                    break;
                case constants.CONTROL_TYPE_FILEATTACHMENT:
                case constants.CONTROL_TYPE_IMAGEIMPORT:
                case constants.CONTROL_TYPE_WEBSIGNATURESIMPLE:
                case constants.CONTROL_TYPE_TABLE_FILEATTACHMENT.toLowerCase():
                    fieldType = constants.FIELD_METADATA_TYPE_ATTACHMENT;
                    break;
            }
        }

        return fieldType;
    }

    resolveStringFieldLength(object) {
        let stringLength;
        let stringLengthStr = '';
        switch (object._type.toLowerCase()) {
            case constants.CONTROL_TYPE_TEXTINPUT:
            case constants.CONTROL_TYPE_TEXTAREA:
            case constants.CONTROL_TYPE_PASSWORDINPUT:
            case constants.CONTROL_TYPE_TABLE_TEXTAREA.toLowerCase():
            case constants.CONTROL_TYPE_TABLE_TEXTINPUT.toLowerCase():
                stringLength = object.Properties._maxChars;
                break;
            case constants.CONTROL_TYPE_TABLE_CHILDFORMBUTTON.toLowerCase():
                stringLength = 32; //Fixed because it gets its length from the attribute formGUID which is a GUID of 32 chars
                break;
            case constants.CONTROL_TYPE_SHOWFORMBUTTON:
                stringLength = 16; //Fixed length
                break;
            case constants.CONTROL_TYPE_DROPDOWN:
            case constants.CONTROL_TYPE_TABLE_DROPDOWN.toLowerCase():
            case constants.CONTROL_TYPE_LIST:
                if (!object.Properties.Property || !object.Properties.Property[0].Item || object.Properties.Property[0].Item.length === 0) {
                    stringLength = 100; // Default value when drop down is empty
                } else {
                    stringLength = self.resolveStringFieldLengthOnDropDown(object);
                }
                break;
            case constants.CONTROL_TYPE_MASKTEXTINPUT:
                stringLength = object.Properties._mask ? object.Properties._mask.length : 0;
                break;
        }

        if (stringLength) {
            stringLengthStr = '(' + stringLength + ')';
        }

        return stringLengthStr;
    }

    //Drop down can be int or string depending on the values on its options
    resolveDropDownListFieldType(dropDown, propertyId) {
        let type = dropDown._type === 'list' ? constants.FIELD_METADATA_TYPE_STRING : constants.FIELD_METADATA_TYPE_INT;
        let countItems = 0;
        let _propertyId = propertyId;
        let maxLength = 0;
        if (!_propertyId) {
            _propertyId = 'values';
        }
        dropDown.Properties.Property.forEach(function (property) {
            if (property._id.toLowerCase() === _propertyId) {
                if (property.Item && property.Item.length) {
                    property.Item.forEach(function (item) {
                        countItems++;
                        if (!util.regexValidation(item._value, constants.REGEX_ONLY_NUMBERS)) {
                            type = constants.FIELD_METADATA_TYPE_STRING;
                            maxLength = 0;
                            return;
                        }
                        let length = 1;
                        if (item._value){
                            length = item._value.toString().length;
                        }

                        maxLength = Math.max(maxLength, item._value.length);
                    });
                }
                return;
            }
        });

        //If the dropdown or list doesn't have any option item then the default type is string
        if (countItems === 0 || maxLength > 9) {
            type = constants.FIELD_METADATA_TYPE_STRING;
        }

        return type;
    }

    //The dropdown takes its string length from the maximum value length
    resolveStringFieldLengthOnDropDown(dropDown, propertyId) {
        let maxLength = 0;
        let _propertyId = propertyId;
        if (!_propertyId) {
            _propertyId = 'values';
        }
        dropDown.Properties.Property.forEach(function (property) {
            if (property._id.toLowerCase() === _propertyId) {
                if (property.Item && property.Item.length) {
                    property.Item.forEach(function (item) {
                        if (item._value && item._value.length > maxLength) {
                            maxLength = item._value.length;
                        }
                    });
                }    
                return;
            }
        });
        return maxLength;
    }

    resolveDefaultValue(object) {
        let controlType = object._type;
        let defaultValue = '';
        if (controlType) {
            switch (controlType.toLowerCase()) {
                case constants.CONTROL_TYPE_TEXTINPUT:
                case constants.CONTROL_TYPE_TEXTAREA:
                case constants.CONTROL_TYPE_PASSWORDINPUT:
                case constants.CONTROL_TYPE_MASKTEXTINPUT:
                case constants.CONTROL_TYPE_NUMERICSTEPPER:
                case constants.CONTROL_TYPE_TABLE_TEXTAREA.toLowerCase():
                case constants.CONTROL_TYPE_TABLE_TEXTINPUT.toLowerCase():
                    if (object.Properties._text) {
                        defaultValue = object.Properties._text;
                    }
                    break;                    
                case constants.CONTROL_TYPE_NUMERICINPUT:
                case constants.CONTROL_TYPE_TABLE_NUMERICINPUT.toLowerCase():
                    if (object.Properties._text) {
                        defaultValue = object.Properties._text;
                    }else{
                        defaultValue = '0';
                    }
                    break;
                case constants.CONTROL_TYPE_RADIOBUTTON:
                case constants.CONTROL_TYPE_CHECKBOX:
                case constants.CONTROL_TYPE_TABLE_CHECKBOX.toLowerCase():
                case constants.CONTROL_TYPE_TABLE_RADIOBUTTON.toLowerCase():
                    defaultValue = util.isTrue(object.Properties._selected);
                    break;                
                case constants.CONTROL_TYPE_TIMEINPUT:
                case constants.CONTROL_TYPE_TABLE_DATEINPUT.toLowerCase():
                case constants.CONTROL_TYPE_TABLE_TIMEINPUT.toLowerCase():
                    if (util.isTrue(object.Properties._showNow)) {
                        defaultValue = 'now';
                    } else if (object.Properties._specific) {
                        defaultValue = object.Properties._specific;
                    }
                    break;
                case constants.CONTROL_TYPE_DATEINPUT:
                case constants.CONTROL_TYPE_DATE:
                    if (util.isTrue(object.Properties._showNow)) {
                        defaultValue = 'now';
                    } else if (object.Properties._specific) {
                        defaultValue = object.Properties._specific.substring(0, 10);
                    }
                    break;
                case constants.CONTROL_TYPE_VERTICALSLIDER:
                case constants.CONTROL_TYPE_HORIZONTALSLIDER:
                    if (object.Properties._value) {
                        defaultValue = object.Properties._value;
                    }
                    break;
                case constants.CONTROL_TYPE_DROPDOWN:
                case constants.CONTROL_TYPE_TABLE_DROPDOWN.toLowerCase():
                case constants.CONTROL_TYPE_TABLE_CHILDFORMBUTTON.toLowerCase():
                    break;
                default:
                    defaultValue = '';
                    break;
            }
        }

        return defaultValue;
    }
}

const formMetadataService = new FormMetadataService();
export default formMetadataService;
